module.exports = "https://www.gc-pro.gnp.com.mx/2da7570cbc94847ec26063849422d649.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/80.svg
// module id = 8045
// module chunks = 0